module.exports = __webpack_public_path__ + "static/img03-32ab88aa11eca0515001b9533c3c20aa.jpg";